module.exports = __webpack_public_path__ + "static/037-b8b4b57e4bcd256d14b82f925d414fd7.jpg";